module.exports = __webpack_public_path__ + "resources/img/img_hi_psm2.da98f8a06b5f9f9bc773e4e1b5347fd1.png";